import React, { useContext } from 'react';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { DefaultContext } from '../../Contexts/DefaultContext';
import { ptbr, eng } from '../../Translate';
import './local.css';
import '../../index.css';

const IOSSlider = styled(Slider)(({ theme }) => ({
    color: 'red',
    height: 5,
    padding: 0,
    '& .MuiSlider-thumb': {
        height: 0,
        width: 0,
    },
    '& .MuiSlider-valueLabel': {
        display: 'none',
    },
    '& .MuiSlider-track': {
        border: 'none',
        height: '0.65rem',
        backgroundColor: '#C6FF00',
        left: '0.5% !important',
    },
    '& .MuiSlider-rail': {
        backgroundColor: '#263238',
        height: '1rem',
        opacity: 1,
        boxShadow: 'inset 0rem 0rem 0.4rem -0.2rem #000',
    },
}));

export default function SkillBar({ ready }) {
    const { LNG } = useContext(DefaultContext)
    const [countToFront, setCountToFront] = React.useState(20);
    const [countToAgile, setCountToAgile] = React.useState(20);
    const [countToEng, setCountToEng] = React.useState(20);
    const [countToDesign, setCountToDesign] = React.useState(20);
    const [countToBack, setCountToBack] = React.useState(20);
    const [countToSoft, setCountToSoft] = React.useState(20)

    React.useEffect(() => {
        if (ready) {
            contadorAutomatico(95, setCountToFront)
            contadorAutomatico(84, setCountToAgile)
            contadorAutomatico(78, setCountToEng)
            contadorAutomatico(83, setCountToDesign)
            contadorAutomatico(83, setCountToBack)
            contadorAutomatico(80, setCountToSoft)
        } else {
            setCountToFront(20)
            setCountToAgile(20)
            setCountToEng(20)
            setCountToDesign(20)
            setCountToBack(20)
            setCountToSoft(20)
        }
    }, [ready])

    const contadorAutomatico = (fim, setCount) => {
        let contador = 0;
        const intervalo = setInterval(function () {
            setCount(contador++);
            if (contador > fim) {
                clearInterval(intervalo); // interrompe o intervalo quando o contador atinge o fim
            }
        }, 50); // intervalo de 1 segundo (1000 milissegundos)
    }

    return (
        <>
            <Box className='skill-bar-frontend'>
                <div className='span-div'>
                    <span className='title-bar'>{LNG ? ptbr.skills.item_2 : eng.skills.item_2}</span>
                    <span className='body-bar'>{`${countToFront}%`}</span>
                </div>
                <IOSSlider value={countToFront} />
            </Box>
            <Box className='skill-bar-agile'>
                <div className='span-div'>
                    <span className='title-bar'>{LNG ? ptbr.skills.item_3 : eng.skills.item_3}</span>
                    <span className='body-bar'>{`${countToAgile}%`}</span>
                </div>
                <IOSSlider value={countToAgile} />
            </Box>
            <Box className='skill-bar-english'>
                <div className='span-div'>
                    <span className='title-bar'>{LNG ? ptbr.skills.item_4 : eng.skills.item_4}</span>
                    <span className='body-bar'>{`${countToEng}%`}</span>
                </div>
                <IOSSlider value={countToEng} />
            </Box>
            <Box className='skill-bar-design'>
                <div className='span-div'>
                    <span className='title-bar'>{LNG ? ptbr.skills.item_5 : eng.skills.item_5}</span>
                    <span className='body-bar'>{`${countToDesign}%`}</span>
                </div>
                <IOSSlider value={countToDesign} />
            </Box>
            <Box className='skill-bar-backend'>
                <div className='span-div'>
                    <span className='title-bar'>{LNG ? ptbr.skills.item_6 : eng.skills.item_6}</span>
                    <span className='body-bar'>{`${countToBack}%`}</span>
                </div>
                <IOSSlider value={countToBack} />
            </Box>
            <Box className='skill-bar-eng'>
                <div className='span-div'>
                    <span className='title-bar'>{LNG ? ptbr.skills.item_7 : eng.skills.item_7}</span>
                    <span className='body-bar'>{`${countToSoft}%`}</span>
                </div>
                <IOSSlider value={countToEng} />
            </Box>
        </>
    );
}